module.exports = __webpack_public_path__ + "media/images/landing/illust/hp-bg-c16069c1886e01ec26c61520266aefab.png";